const MIN_RIR = 0;
const MAX_RIR = 4;

function clampSeededRir(value) {
  return Math.max(MIN_RIR, Math.min(MAX_RIR, value));
}

export function convertDemoSeedIntensityValue(value, useRir = false) {
  if (!useRir) return value;
  if (value === "" || value === null || value === undefined) return value;

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return value;
  if (numericValue <= 0) return 0;

  return clampSeededRir(Math.round(10 - numericValue));
}

export function convertDemoSeedProtocolText(text, useRir = false) {
  if (!useRir || typeof text !== "string" || text.trim() === "") {
    return text;
  }

  return text.replace(/@(\d+(?:\.\d+)?)/g, (_, intensityValue) => {
    const convertedValue = convertDemoSeedIntensityValue(
      Number(intensityValue),
      true,
    );
    return `@${convertedValue}`;
  });
}
